define(["require", "exports", "jquery", "./signup"], function (require, exports, $, signup_1) {
    "use strict";
    exports.__esModule = true;
    function default_1(message, saving, actionBar) {
        var dlgClassName = "signup-coupon-dialog";
        var $dlg = $(dlgClassName);
        var closeDlg = function (xdlg) {
            xdlg.dialog('close');
            xdlg.actionBar({
                onclick: signup_1["default"],
                clickTarget: xdlg
            }).show();
        };
        if ($dlg.length === 0) {
            var emailSignup = "<button class=\"email-signup\" type=\"submit\">Sign up</button>";
            var signupLater = "<a href='.' class='signupLater'>Not now</a>";
            var actions = "<div class=\"actions\">" + emailSignup + signupLater + "</div>";
            $dlg = $("<div class=\"" + dlgClassName + "\"><h3 class=\"title\">" + message + "</h3><p></p>" + actions + "</div>");
            $dlg.appendTo($('body'));
            $dlg.find('.email-signup').click(function (evt) {
                var $parent = $dlg.parent();
                $dlg.dialog('close');
                if ($parent.hasClass('bottom-action-bar')) {
                    $parent.remove();
                }
                signup_1["default"]();
            });
            $dlg.find('.signupLater').click(function (evt) {
                evt.preventDefault();
                evt.stopPropagation();
                closeDlg($dlg);
            });
        }
        if ($dlg.closest('.bottom-action-bar').length) {
            return;
        }
        if (actionBar) {
            $dlg.actionBar({
                onclick: signup_1["default"],
                clickTarget: $dlg
            });
            return;
        }
        $dlg.dialog('show');
        $dlg.find('.closer').unbind('click').bind('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            closeDlg($dlg);
        });
    }
    exports["default"] = default_1;
});



//////////////////
// WEBPACK FOOTER
// ./Scripts/built/dialogs/promptSignup.js
// module id = 66
// module chunks = 0